// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  mapId: __t.string().name("map_id"),
  name: __t.string(),
  mapKind: __t.string().name("map_kind"),
  gridType: __t.string().name("grid_type"),
  width: __t.u32(),
  height: __t.u32(),
});
